'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Sealed$package$Otter$1(name, age) {
  this.t5 = null;
  this.t4 = 0;
  this.t5 = name;
  this.t4 = age;
}
export { $c_Lsamples_Sealed$package$Otter$1 as $c_Lsamples_Sealed$package$Otter$1 };
$p = $c_Lsamples_Sealed$package$Otter$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Sealed$package$Otter$1;
/** @constructor */
function $h_Lsamples_Sealed$package$Otter$1() {
}
export { $h_Lsamples_Sealed$package$Otter$1 as $h_Lsamples_Sealed$package$Otter$1 };
$h_Lsamples_Sealed$package$Otter$1.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  var acc = (-889275714);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, 76528636);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.t5));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, this.t4);
  return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 2);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsamples_Sealed$package$Otter$1) && ((this.t4 === x$0.t4) && (this.t5 === x$0.t5))));
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 2;
});
$p.o = (function() {
  return "Otter";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.t5;
  }
  if ((n === 1)) {
    return this.t4;
  }
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lsamples_Sealed$package$Otter$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eq)));
}
export { $isArrayOf_Lsamples_Sealed$package$Otter$1 as $isArrayOf_Lsamples_Sealed$package$Otter$1 };
var $d_Lsamples_Sealed$package$Otter$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Sealed$package$Otter$1, "samples.Sealed$package$Otter$1", ({
  eq: 1,
  by: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lsamples_Sealed$package$Otter$1 as $d_Lsamples_Sealed$package$Otter$1 };
